// Une seule couleur est saisie par la mairie. Le reste en découle, et on
// n'accepte jamais un contraste sous le seuil légal de 4,5 pour 1.
const hex2rgb = (h) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16))
const rgb2hex = (r) => '#' + r.map((v) => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, '0')).join('')

function luminance(h) {
  const s = hex2rgb(h).map((v) => {
    v /= 255
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4
  })
  return 0.2126 * s[0] + 0.7152 * s[1] + 0.0722 * s[2]
}

export function contrast(a, b) {
  const [l1, l2] = [luminance(a), luminance(b)]
  return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05)
}

export function shade(h, p) {
  const r = hex2rgb(h)
  return rgb2hex(p < 0 ? r.map((v) => v * (1 + p)) : r.map((v) => v + (255 - v) * p))
}

export function palette(primary = '#1B3B8F') {
  let pri = primary
  let fixed = false
  let guard = 0
  while (contrast(pri, '#ffffff') < 4.5 && guard++ < 24) {
    pri = shade(pri, -0.06)
    fixed = true
  }
  return {
    pri,
    dark: shade(pri, -0.22),
    pale: shade(pri, 0.88),
    txt: contrast(pri, '#ffffff') >= contrast(pri, '#101828') ? '#ffffff' : '#101828',
    ratio: Math.round(contrast(pri, '#ffffff') * 10) / 10,
    originalRatio: Math.round(contrast(primary, '#ffffff') * 10) / 10,
    fixed,
  }
}

export function applyTheme(theme = {}) {
  const p = palette(theme.primary || '#1B3B8F')
  const radius = { net: '2px', doux: '10px', rond: '22px' }[theme.radius || 'doux']
  const root = document.documentElement.style
  root.setProperty('--pri', p.pri)
  root.setProperty('--pri-d', p.dark)
  root.setProperty('--pri-pale', p.pale)
  root.setProperty('--pri-txt', p.txt)
  root.setProperty('--rad', radius)
  root.setProperty('--ff', `"${theme.font || 'Public Sans'}", system-ui, sans-serif`)
  return p
}
